export class HalcyonFormCatalogApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getFormCatalog() {
    return this.#http.get('/halcyon/form-catalog');
  }
}
